<template>
<div>
    <!-- メイン -->
    <v-main class="bg-image">
      <v-container class="container-16">
        <v-card :loading="loading" class="mx-auto py-0 my-sm-12" :max-width="inputLoginWidth" >
          <template slot="progress">
            <v-progress-linear
              color="deep-purple"
              height="10"
              indeterminate
            ></v-progress-linear>
          </template>

          <div class="rogo pt-0 img-box">
            <!-- <v-img height="220px" src="../assets/img/information.png"></v-img> -->
            <!-- <p>登&nbsp;記&nbsp;<span class="logo_rotate">託</span></p> -->
            <!-- <v-img class="tqsman" src="../assets/img/mait-girl.png"></v-img> -->
            <v-img height="220px" src="../assets/img/crop06ellyfdesk845.jpg"></v-img>
            <p align="center" class="img-box-center">{{ $t("LCMV000") }}</p>
            <v-img class="tqswoman" src="../assets/img/1646_paint.png"></v-img>
          </div>

          <v-card-title></v-card-title>

          <v-card-text>
            <v-row align="center" class="mx-0">
              <v-text-field label="システムID" single-line solo v-model="systemId"></v-text-field>
            </v-row>
            <v-row align="center" class="mx-0">
              <v-text-field label="ユーザID" single-line solo v-model="roginId"></v-text-field>
            </v-row>
            <v-row align="center" class="mx-0">
              <v-text-field
                solo
                v-model="password"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                label="パスワード"
                counter
                @click:append="show1 = !show1"
              ></v-text-field>
            </v-row>
            <v-card class="d-flex justify-center mb-0" flat>
              <v-checkbox
                v-model="chkboxSP"
                label="ログイン情報を保存する"
              ></v-checkbox>
            </v-card>
            <!-- <v-row class="mt-8" style="height: 5vh;">
            </v-row> -->
            <v-card class="d-flex justify-center mb-6" flat>
              <v-card-actions>
                <v-btn x-large color="green lighten-1" dark min-width="200px" @click="login()">{{ $t("LMB001") }}</v-btn>
              </v-card-actions>
            </v-card>
            <v-row class="mt-1" style="height: 2vh;"></v-row>
            <v-card class="d-flex justify-center mb-6" flat>
              <router-link :to="{name:'PSS100'}">ホームページへ戻る</router-link>
            </v-card>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
    <!-- フッター -->
    <!-- その他 -->
    <comMessage :msg="dlgMsg.msg" :is-open="dlgMsg.isOpen" :do-yes="dlgMsg.doYes"/>
  </div>
</template>
<script>
import Constants from "../common/constantsVf";
import Utils from "../common/utils";
export default {
  name: "VFLogin",
  data() {
    return {
      screenTitle: "ログイン",
      screenId: "VFA100",
      name: "vflogin",
      loading: false,
      roginId: "",
      systemId: "",
      show1: false,
      password: "",
      chkboxSP: false,
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },
    };
    
  },
  computed: {
    inputLoginWidth() {
      let bp =this.$vuetify.breakpoint.name;
      if (bp == 'xs' ) {
        return "100%";
      } else if (bp == 'md' || bp == 'sm') {
        return "80%";
      } else if (bp == 'lg' || bp == 'xl') {
        return "60%";
      } else {
        return "46%";
      }
    }
  },
created() {
    this.initialize();
  },
  methods: {
   /*
    * 初期表示
    */
    initialize: function() {
      let hasCookie = this.getCookieArray();
      if (hasCookie) {
        this.chkboxSP = true;
      }
    },
    /*
     * ログインボタン押下
     */
    login: async function() {
      this.loading = true;
      // 単項目チェック
      let chkRslt = this.checkForLogin();
      if (!chkRslt) {
        this.loading = false;
        return;
      }
      let errStatus = null;
      // ログインサービス呼び出し
      let apiurl = Constants.URL_API_VFA100G01;
      try {
        let data = JSON.stringify({username: this.systemId + this.roginId, password: this.password});
        let response = await this.$axios.post(apiurl, data, 
            {
              headers: {"content-type": "application/json"}, 
              responseType: "json",
            });
        let accessToken = response.headers['x-auth-token'];
        this.$store.dispatch("vfAuthcUser/setAccessToken", accessToken);
        if (this.chkboxSP) {
          let expire = new Date();
          expire.setTime( expire.getTime() + 30 * 1000 * 3600 * 24 );
          let expireStringVal = "; expires=" + expire.toUTCString();
          
          document.cookie = "verifysystemId=" + this.systemId + expireStringVal;
          document.cookie = "verifyroginId=" + this.roginId + expireStringVal;
          document.cookie = "verifypassword=" + this.password + expireStringVal;
        }
        // 検索画面用ストアデータ破棄
        this.clearSearchConditions();
        this.$router.push(this.$router.resolve({ name: "VFV100" }).href);
      } catch(error) {
        errStatus = error.response.status;
      } finally {
        this.loading = false;
      }

      if (errStatus != null) { 
        if (errStatus >= 400 && errStatus < 500) {
          this.dlgMsg.msg = this.$i18n.t('msg.err.vfv071');
          this.dlgMsg.isOpen = true;
        } else {
          this.dlgMsg.msg = this.$i18n.t('msg.err.cm500');
          this.dlgMsg.isOpen = true;
        }
      }
    },


    checkForLogin: function() {
      let retVal = false;
      if (!this.unitCheckForLogin()) {
        return retVal;
      }
      retVal = true;
      return retVal;
    },

    unitCheckForLogin: function() {
      let retVal = true;
      let errList = new Array();
      this.$i18n
      if (this.roginId == "") {
        errList.push(this.$i18n.t('msg.err.cm020', ['ユーザID']));
      }
      if (this.systemId == "") {
        errList.push(this.$i18n.t('msg.err.cm020', ['システムID']));
      }
       if (this.password == "") {
        errList.push(this.$i18n.t('msg.err.cm020', ['パスワード']));
      }
      if (errList.length > 0) {
        retVal = false;
        this.dlgMsg.msg = Utils.createMsgViewString(errList);
        this.dlgMsg.isOpen = true;
      }
      return retVal;
    },

    getCookieArray: function() {
      let hasCookies = false; 
      let arr = new Array()
      if (document.cookie != '') {
        let tmp = document.cookie.split('; ');
        for (let i = 0; i < tmp.length; i++) {
            let data = tmp[i].split('=');
            arr[data[0]] = decodeURIComponent(data[1])
        }
        if (arr['verifysystemId'] !== '' && arr['verifyroginId'] !== '' && arr['verifypassword'] !== '') {
            hasCookies = true
            this.roginId = arr['verifyroginId'];
            this.systemId = arr['verifysystemId'];
            this.password = arr['verifypassword'];
        }
      }
      return hasCookies;
    },

    clearSearchConditions: function() {
      // 検索画面用データストア破棄
      this.$store.commit("vfReceiptAppListSearch/resetState");
      this.$store.commit("vfVerifyUserListSearch/resetState");
    }, 
  },

}
</script>
<style scoped>

.bg-image {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-size: cover;
  background-image: url("../assets/img/p0051_m.jpg");
  background-color: rgba(200, 206, 243, 0.8);
  background-blend-mode: lighten;
}

.rogo {
  position: relative;
  /* font-family: "HGP行書体", "Roboto", "ＭＳ Ｐ明朝", "MS PMincho", "STKaiti",
    "ヒラギノ明朝 Pro W3", "Hiragino Mincho Pro", serif !important; */
    font-family: "HG丸ｺﾞｼｯｸM-PRO", "HGP創英角ﾎﾟｯﾌﾟ体", "HGP創英角ｺﾞｼｯｸUB", "ＭＳ ゴシック";
  font-weight: bold;
  font-size: 1.8em;
}

.tqswoman {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  top: 75%;
  left: 75%;
  width: 60px;
  height: auto;
}

.img-box {
  position: relative;
  height: auto;
  margin: 0 auto;
}
.img-box-center {
  position: absolute; 
  top: 84%;
  right: 30%;
  transform: translateY(-124%);
}
</style>